import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { Autocomplete, Box, Checkbox, FormControlLabel, InputAdornment, Typography } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import EndDatePicker from './EndDatePicker/EndDatePicker';
import { request } from '../../../config';
import { getFormatedDate } from '../../../helpers/fotmatDate';
import Loading from '../Loading/Loading';
import OtpModal from '../../../copms/Modal/OtpModal';

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}

class Detailed extends Component {
    state = {
        status: 1,
        excelFileOutline: false,
        toDate: null,
        fromDate: null,
        expireDate: null,
        search: '',
        currentPage: 1,
        lastPage: 0,
        cards: [],
        accountList: [],
        consentTime: [],
        accounts: [],
        ibanList: [],
        expireDateId: null,
        timer: '',
        consentContent: '',
        isChecked: false,
        openModal: false,
        isLoading: false
    }

    setValues = (value, name) => {
        let newFormData = {
            ...this.state.formData,
            [name]: value
        };
        this.setState({ formData: newFormData })
    };

    getFormatedDate(date) {
        if (date) {
            let formatedDate = {
                day: (date.getDate() < 9) ? ('0' + date.getDate()) : date.getDate(),
                month: (date.getMonth() < 9) ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1),
                year: date.getFullYear().toString()
            }
            return formatedDate.year + '-' + formatedDate.month + '-' + formatedDate.day;
        }
        return null;
    }

    getConsentDetailById = () => {
        // this.props.updateAppState('isLoadingTransparentBackground', true);
        let { link } = this.state;
        let getConsentDetailByIdRequestBody = link === 'account' ? {
            token: localStorage.getItem('token'),
            currency: this.state.consent?.currency,
            iban: this.state.consent?.iban,
            pan: this.state.consent?.cardNumber,
            accountId: this.state.consent?.accountId,
        } : {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            consentId: this.state.consent?.id,
            tin: this.state.consent?.tin
        }
        fetch(request(`account/${link === 'account' ? "getRelatedConsentAccountDetail" : "getConsentDetailById"}`, getConsentDetailByIdRequestBody))
            .then(res => res.text())
            .then((getConsentDetailByIdResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getConsentDetailByIdResponse = JSON.parse(getConsentDetailByIdResponseJSON);
                if (getConsentDetailByIdResponse.status.statusCode !== 1) {
                    if (getConsentDetailByIdResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        // this.props.updateAppState('isLoadingTransparentBackground', false);
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getConsentDetailByIdResponse.status.statusCode));
                    }
                } else {
                    // this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.setState({ consent: getConsentDetailByIdResponse })
                }
                this.setState({ isLoading: false })
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getCardAccountList = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getAccountListRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("account/getCardListForConsent", getAccountListRequestBody))
            .then(res => res.text())
            .then((getCardAccountListResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getCardAccountListResponse = JSON.parse(getCardAccountListResponseJSON);
                if (getCardAccountListResponse.status.statusCode !== 1) {
                    if (getCardAccountListResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getCardAccountListResponse.status.statusCode));
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({ cards: getCardAccountListResponse?.cardList ? getCardAccountListResponse?.cardList?.length != 0 ? getCardAccountListResponse?.cardList : [] : [] }, () => {
                    fetch(request(("account/getNoCardAccountListForConsent"), getAccountListRequestBody))
                        .then(res => res.text())
                        .then((getCardAccountListResponseJSON) => {
                            const JSON = require('true-json-bigint');
                            let getCardAccountListResponse = JSON.parse(getCardAccountListResponseJSON);
                            if (getCardAccountListResponse.status.statusCode !== 1) {
                                if (getCardAccountListResponse.status.statusCode === 200) {
                                    this.props.logout();
                                } else {
                                    this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getCardAccountListResponse.status.statusCode));
                                }
                            }
                            this.props.updateAppState('isLoadingTransparentBackground', false);
                            this.setState({ accountList: getCardAccountListResponse?.accountList ? getCardAccountListResponse?.accountList?.length != 0 ? getCardAccountListResponse?.accountList : [] : [] });
                        },
                            (error) => {
                                this.props.history.push("/technical-break");
                            });
                });
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getConsentTimes = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getConsentTimesRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        fetch(request("account/getConsentTimes", getConsentTimesRequestBody))
            .then(res => res.text())
            .then((getConsentTimesResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getConsentTimesResponse = JSON.parse(getConsentTimesResponseJSON);
                if (getConsentTimesResponse.status.statusCode !== 1) {
                    if (getConsentTimesResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getConsentTimesResponse.status.statusCode));
                    }
                }
                this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({ consentTime: getConsentTimesResponse?.consentTime ? getConsentTimesResponse?.consentTime?.length != 0 ? getConsentTimesResponse?.consentTime : [] : [] });
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    addConsentAccount = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let addConsentAccountRequestBody = {
            consentId: this.state.consent?.id,
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            accounts: this.state.accounts,
            ibanList: this.state.ibanList,
            expireDate: getFormatedDate(this.state.expireDate, 'dd.mm.yyyy'),
            expireDateId: this.state.expireDateId
        }
        fetch(request("account/addConsentAccount", addConsentAccountRequestBody))
            .then(res => res.text())
            .then((addConsentAccountResponseJSON) => {
                const JSON = require('true-json-bigint');
                let addConsentAccountResponse = JSON.parse(addConsentAccountResponseJSON);
                if (addConsentAccountResponse.status.statusCode !== 1) {
                    if (addConsentAccountResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'redirect', this.props.t('an error occurred'), this.props.t(addConsentAccountResponse.status.statusCode), this.state.consent?.nokRedirectUrl);
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                } else {
                    this.setState({ consentContent: this.downloadPdf(addConsentAccountResponse.consentContent), mobile: addConsentAccountResponse.mobile, consentId: addConsentAccountResponse.consentId })
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    sendConsentOtp = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let sendConsentOtpRequestBody = {
            consentId: this.state.consent?.id,
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            mobile: JSON.parse(localStorage.getItem('custObject'))?.customer?.mobile || JSON.parse(localStorage.getItem('custObject'))?.mobile,
        }
        fetch(request("account/sendConsentOtp", sendConsentOtpRequestBody))
            .then(res => res.text())
            .then((sendConsentOtpResponseJSON) => {
                const JSON = require('true-json-bigint');
                let sendConsentOtpResponse = JSON.parse(sendConsentOtpResponseJSON);
                if (sendConsentOtpResponse.status.statusCode !== 1) {
                    if (sendConsentOtpResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'redirect', this.props.t('an error occurred'), this.props.t(sendConsentOtpResponse.status.statusCode), this.state.consent?.nokRedirectUrl);
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                } else {
                    this.setState({ openModal: true, verifyToken: sendConsentOtpResponse.verifyToken })
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    verifyConsentOtp = (confirmCode) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let verifyConsentOtpRequestBody = {
            consentId: this.state.consent?.id,
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            verifyToken: this.state.verifyToken,
            confirmCode
        }
        fetch(request("account/verifyConsentOtp", verifyConsentOtpRequestBody))
            .then(res => res.text())
            .then((verifyConsentOtpResponseJSON) => {
                const JSON = require('true-json-bigint');
                let verifyConsentOtpResponse = JSON.parse(verifyConsentOtpResponseJSON);
                if (verifyConsentOtpResponse.status.statusCode !== 1) {
                    if (verifyConsentOtpResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else if (verifyConsentOtpResponse.status.statusCode === 630) {
                        this.props.alertState(true, 'redirect', this.props.t('an error occurred'), this.props.t(verifyConsentOtpResponse.status.statusCode), this.state.consent?.nokRedirectUrl);
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(verifyConsentOtpResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                } else {
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(verifyConsentOtpResponse.status.statusCode), null, null, window.open(this.state.consent?.redirectUrl));
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    componentDidMount() {
        this.setState({
            isLoading: true, link: window.location.pathname.split('/')[5], consent: this.props.location.state.item
        }, () => {
            if (this.state.link === 'incoming') {
                this.startCountdownFromGivenTime();
                this.getCardAccountList();
                this.getConsentTimes();
            } else if (this.state.link === 'sent') {
                this.startCountdownFromGivenTime();
            } else if (this.state.link !== 'item') {
                this.getConsentDetailById();
            } else {
                this.setState({ isLoading: false })
            }
        });
    }

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    startCountdownFromGivenTime = () => {
        const givenTime = new Date(this.state.consent?.createdAt || this.state.consent?.createdAt);
        const targetTime = new Date(givenTime.getTime() + 10 * 60 * 1000);
        const now = new Date();
        const timeLeftInitial = targetTime - now;

        if (timeLeftInitial <= 0) {
            this.setState({ timer: '00:00', isLoading: false })
            return;
        }

        const interval = setInterval(() => {
            const now = new Date();
            const timeLeft = targetTime - now;

            if (timeLeft <= 0) {
                this.setState({ timer: '00:00' })
                clearInterval(interval);
                return;
            }

            const minutes = Math.floor(timeLeft / (60 * 1000));
            const seconds = Math.floor((timeLeft % (60 * 1000)) / 1000);
            const display = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            this.setState({ timer: display, isLoading: false })
        }, 1000);


    }

    downloadPdf = (file, filename) => {
        let arrrayBuffer = base64ToArrayBuffer(file); //data is the base64 encoded string
        let blob = new Blob([arrrayBuffer], { type: "application/pdf" });
        return window.URL.createObjectURL(blob);
    }

    render() {
        let { link, consent, timer, accountList, cards, consentTime, expireDateId, isLoading, consentContent, isChecked, openModal } = this.state;
        let { t } = this.props;
        return (
            <>
                <OtpModal open={openModal} sendConsentOtp={this.sendConsentOtp} signSubmit={(val) => this.verifyConsentOtp(val)} onClose={() => this.setState({ openModal: false })} />
                {/* <YesNoModal open={open} title={t('Əməliyyatı silmək istədiyinizdən əminsiniz?')} onClose={() => this.setState({ open: false })} triggerFunc={(bool) => bool ? this.deleteSalaryOrder(id) : this.setState({ open: false })} /> */}
                {link !== 'account' && link !== 'item' &&
                    <div className="dashboard-transfer-list-header">
                        <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                            <NavLink to="/dashboard/open-banking/list/consents/given" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Given consents")}</NavLink>
                            <NavLink to="/dashboard/open-banking/list/consents/incoming" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Incoming consent request")}</NavLink>
                            <NavLink to="/dashboard/open-banking/list/consents/sent" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Sent consent request")}</NavLink>
                        </div>
                    </div>}
                {isLoading ? <Loading /> :
                    <div className="dashboard-salary-order-container open-banking" style={{ overflow: 'visible', height: '100%' }}>
                        <h3 class="dashboard-payment-container-data-section-content-container-title">{t('Information')}</h3>
                        <div className="dashboard-account-container-component align-items-start" style={{ maxWidth: 672 }}>
                            {link === 'given' ? <>
                                <TextField variant="outlined" sx={{ width: 320 }} inputProps={{ readOnly: true }} value={consent?.bankName} label={t('Consent giver')} />
                                <Box sx={{ width: 320, top: '-4px', position: 'relative' }}>
                                    <label>{t('Account or card')}</label>
                                    <ol style={{ paddingInline: 30, paddingBlock: 12, border: '1px solid #D0D5DD', margin: 0 }}>
                                        {consent?.accounts?.map(item => <li>{item?.pan || item?.iban + item?.overdraft}</li>)}
                                    </ol>
                                </Box>
                                <TextField variant="outlined" sx={{ width: 320 }} inputProps={{ readOnly: true }} value={consent?.consentTime} label={t('Consent duration')} />
                                <TextField variant="outlined" sx={{ width: 320 }} inputProps={{ readOnly: true }} value={consent?.consentStatus} label={t('Status')} />
                                <TextField variant="outlined" sx={{ width: 320 }} inputProps={{ readOnly: true }} value={consent?.startDate} label={t('Başlanma tarixi')} />
                                <TextField variant="outlined" sx={{ width: 320 }} inputProps={{ readOnly: true }} value={consent?.endDate} label={t('expiration date')} />
                            </> : link === 'incoming' ? <>
                                <TextField variant="outlined" sx={{ width: 350 }} inputProps={{ readOnly: true }} value={consent?.bankName} label={t('Organization')} />
                                <TextField variant="outlined" sx={{ width: 350 }} inputProps={{ readOnly: true }} value={consent?.tin} label={t('tin')} />
                                <Autocomplete
                                    sx={{ width: 350 }}
                                    className='open-banking'
                                    disablePortal
                                    options={consentTime}
                                    getOptionLabel={(option) => option.text}
                                    // value={}
                                    onChange={(event, value) => this.setState({ expireDateId: value?.id, expireDate: null })}
                                    renderInput={(params) => <TextField {...params} placeholder={t('Choose')} label={t('Consent duration')} />} />
                                <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                    {expireDateId == 4 && <>
                                        <EndDatePicker placeholder={t("DD.MM.YYYY")}
                                            minDate={new Date(new Date().setDate(new Date().getDate() + consentTime.find(item => item.id == expireDateId).fromDay))}
                                            maxDate={new Date(new Date().setDate(new Date().getDate() + consentTime.find(item => item.id == expireDateId).toDay))}
                                            width={160} label={t('Other (Select)')} name="expireDate" value={this.state.expireDate} updateDate={this.updateDate} />
                                    </>}
                                </Box>
                                <Autocomplete
                                    className='open-banking'
                                    multiple
                                    disablePortal
                                    disableCloseOnSelect
                                    limitTags={1}
                                    disableListWrap
                                    options={[...accountList.map(a => ({ ...a, type: t('accounts') })), ...cards.map(c => ({ ...c, type: t('cards') }))]}
                                    groupBy={(option) => option.type}
                                    getOptionLabel={(option) => option.cardNumber || option.iban + option?.overdraft || 'Unnamed'}
                                    isOptionEqualToValue={(option, value) => option.accountId == value.accountId}
                                    onChange={(event, value) => this.setState({ accounts: value.map(item => item.accountId), ibanList: value.filter(item => item?.iban).map(item => item.iban) })}
                                    renderOption={(props, option, { selected }) => {
                                        const { key, ...optionProps } = props;
                                        return (
                                            <li key={key} {...optionProps}>
                                                <Checkbox
                                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    // style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.cardNumber || option.iban + option?.overdraft || 'Unnamed'}
                                            </li>
                                        );
                                    }}
                                    sx={{
                                        width: 350,
                                        '.MuiOutlinedInput-root': {
                                            flexWrap: 'nowrap',
                                            overflow: 'hidden'
                                        },
                                        'div.MuiAutocomplete-tag': {
                                            maxWidth: '160px'
                                        },
                                        'div.MuiAutocomplete-tag:not(:nth-child(1))': {
                                            display: 'none'
                                        }
                                    }}
                                    renderInput={(params) => <TextField className='flex-nowrap' {...params} placeholder={t('Choose')} label={t('Cards and Accounts')} />}
                                />
                                <TextField variant="outlined" inputProps={{ readOnly: true }} value={timer} sx={{ width: 160 }} label={t('Consent validity period')}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="start" className='ml-3'><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M11.107 10.9916C11.4475 11.1052 11.8156 10.9211 11.9291 10.5805C12.0427 10.24 11.8586 9.87188 11.518 9.75836L11.107 10.9916ZM8.5 9.4375H7.85C7.85 9.71728 8.02903 9.96567 8.29445 10.0541L8.5 9.4375ZM9.15 5.51739C9.15 5.15841 8.85898 4.86739 8.5 4.86739C8.14102 4.86739 7.85 5.15841 7.85 5.51739H9.15ZM11.518 9.75836L8.70555 8.82086L8.29445 10.0541L11.107 10.9916L11.518 9.75836ZM9.15 9.4375V5.51739H7.85V9.4375H9.15ZM15.35 8.5C15.35 12.2832 12.2832 15.35 8.5 15.35V16.65C13.0011 16.65 16.65 13.0011 16.65 8.5H15.35ZM8.5 15.35C4.71685 15.35 1.65 12.2832 1.65 8.5H0.35C0.35 13.0011 3.99888 16.65 8.5 16.65V15.35ZM1.65 8.5C1.65 4.71685 4.71685 1.65 8.5 1.65V0.35C3.99888 0.35 0.35 3.99888 0.35 8.5H1.65ZM8.5 1.65C12.2832 1.65 15.35 4.71685 15.35 8.5H16.65C16.65 3.99888 13.0011 0.35 8.5 0.35V1.65Z" fill="#0179D2" />
                                        </svg></InputAdornment>
                                    }} />
                                {consentContent && <FormControlLabel className='w-100' checked={isChecked} onChange={(e) => this.setState({ isChecked: e.target.checked })} control={<Checkbox />} label={<p className='m-0'><a href={consentContent} target='_blank' rel="noopener noreferrer">{t('Application')}</a> ilə tanış oldum</p>} />}
                                <Typography sx={{ width: 352, fontSize: '14px' }}>{t('Information')}. <br />{t('This consent provides access only to selected data. You can revoke the consent at any time.')}</Typography>
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main ml-auto" disabled={consentContent ? !isChecked : false} onClick={() => consentContent ? this.sendConsentOtp() : this.addConsentAccount()}>{t("continue")}</button>
                            </> : link === 'sent' ? <>
                                <TextField variant="outlined" inputProps={{ readOnly: true }} sx={{ width: 192 }} value={consent?.bankName} label={t('Organization')} />
                                <TextField variant="outlined" inputProps={{ readOnly: true }} sx={{ width: 220 }} value={consent?.tin} label={t('tin')} />
                                <TextField variant="outlined" inputProps={{ readOnly: true }} sx={{ width: 158 }} value={timer} label={t('Consent validity period')}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="start"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M11.107 10.9916C11.4475 11.1052 11.8156 10.9211 11.9291 10.5805C12.0427 10.24 11.8586 9.87188 11.518 9.75836L11.107 10.9916ZM8.5 9.4375H7.85C7.85 9.71728 8.02903 9.96567 8.29445 10.0541L8.5 9.4375ZM9.15 5.51739C9.15 5.15841 8.85898 4.86739 8.5 4.86739C8.14102 4.86739 7.85 5.15841 7.85 5.51739H9.15ZM11.518 9.75836L8.70555 8.82086L8.29445 10.0541L11.107 10.9916L11.518 9.75836ZM9.15 9.4375V5.51739H7.85V9.4375H9.15ZM15.35 8.5C15.35 12.2832 12.2832 15.35 8.5 15.35V16.65C13.0011 16.65 16.65 13.0011 16.65 8.5H15.35ZM8.5 15.35C4.71685 15.35 1.65 12.2832 1.65 8.5H0.35C0.35 13.0011 3.99888 16.65 8.5 16.65V15.35ZM1.65 8.5C1.65 4.71685 4.71685 1.65 8.5 1.65V0.35C3.99888 0.35 0.35 3.99888 0.35 8.5H1.65ZM8.5 1.65C12.2832 1.65 15.35 4.71685 15.35 8.5H16.65C16.65 3.99888 13.0011 0.35 8.5 0.35V1.65Z" fill="#0179D2" />
                                        </svg></InputAdornment>
                                    }} />
                            </> : link === 'account' ? <>
                                <TextField variant="outlined" sx={{ width: '70%' }} inputProps={{ readOnly: true }} value={consent?.iban + consent?.overdraft + (consent?.cardNumber ? " / " + consent?.cardNumber : "")} label={t('account number')} />
                                <TextField variant="outlined" sx={{ width: 81 }} inputProps={{ readOnly: true }} value={consent?.currency} label={t('currency')} />
                                {consent?.banks && consent?.banks.length > 0 && consent?.banks.map((item, index) =>
                                    <Box display={'flex'} flexWrap={'wrap'} columnGap={1} rowGap={3}>
                                        {index != 0 && <hr />}
                                        <TextField variant="outlined" sx={{ width: 266 }} inputProps={{ readOnly: true }} value={item?.name} label={t('Consent giver')} />
                                        <TextField variant="outlined" sx={{ width: 150 }} inputProps={{ readOnly: true }} value={item?.startDate} label={t('Date given')}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="start"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                    <path d="M4.32861 12.8501V12.7857M8.26611 12.8501V12.7857M8.26611 9.35714V9.29269M11.7661 9.35714V9.29269M1.70361 5.92855H13.9536M3.28695 1V2.28586M12.2036 1V2.28571M12.2036 2.28571H3.45361C2.00387 2.28571 0.828613 3.43697 0.828613 4.85712V13.4286C0.828613 14.8487 2.00387 16 3.45361 16H12.2036C13.6534 16 14.8286 14.8487 14.8286 13.4286L14.8286 4.85712C14.8286 3.43697 13.6534 2.28571 12.2036 2.28571Z" stroke="#0179D2" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg></InputAdornment>
                                            }} />
                                        <TextField variant="outlined" sx={{ width: 150 }} inputProps={{ readOnly: true }} value={item?.endDate} label={t('expiration date')}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="start"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                                    <path d="M4.32861 12.8501V12.7857M8.26611 12.8501V12.7857M8.26611 9.35714V9.29269M11.7661 9.35714V9.29269M1.70361 5.92855H13.9536M3.28695 1V2.28586M12.2036 1V2.28571M12.2036 2.28571H3.45361C2.00387 2.28571 0.828613 3.43697 0.828613 4.85712V13.4286C0.828613 14.8487 2.00387 16 3.45361 16H12.2036C13.6534 16 14.8286 14.8487 14.8286 13.4286L14.8286 4.85712C14.8286 3.43697 13.6534 2.28571 12.2036 2.28571Z" stroke="#0179D2" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg></InputAdornment>
                                            }} />
                                    </Box>)}
                                <Typography sx={{ fontSize: '14px' }}>{t("Information")}. <br />{t("To disconnect this account from the organization, you must first revoke the given consent. Then, you can create a new consent and select your other accounts.")}</Typography>
                            </> : <>
                                <TextField variant="outlined" sx={{ width: 320 }} value={consent?.iban + consent?.overdraft} label={t('account number')} />
                                <TextField variant="outlined" sx={{ width: 143 }} value={consent?.creditDebitIndicator} label={t('Type of transaction')} />
                                <TextField variant="outlined" sx={{ width: 320 }} value={consent?.transactionReference} label={t('Document number')} />
                                <TextField variant="outlined" sx={{ width: 184 }} value={consent?.bookingDateTime} label={t('date')} />
                                <TextField variant="outlined" sx={{ width: 320 }} value={consent?.amount + " " + consent?.currency} label={t('Amount')} />
                                <TextField variant="outlined" sx={{ width: 184 }} value={consent?.description} label={t('Appointment')} /></>}
                        </div>
                    </div>}
            </>
        )
    }
}

export default translate("translation")(Detailed);